import { DefaultTheme } from 'styled-components';

export const darkTheme: DefaultTheme = {
  bgColor: " #000035",
  textColor: " #f5f6fa",
  secondColor: " #000035",
  thirdColor: "rgb(165, 165, 165)",
  accentColor: " #8c7ae6",
  mainColor: " #33ff99"
}